import { ComponentPropsWithoutRef, PropsWithChildren } from "react";
import * as styles from "./CardArchive.css";
import { CardArchive as TCardArchive } from "~/sanity/types";
import { Heading } from "~/components/elements/Heading";
import PortableText, {
  IPortableText,
} from "~/components/portableText/PortableText";
import { ButtonLink } from "~/components/elements/ButtonLink";
import { IImage, Image } from "~/components/elements/Image";
// @ts-ignore
import ArrowOutward from "@material-design-icons/svg/filled/arrow_outward.svg?react";
import clsx from "clsx";
import { Tag, TagProps } from "~/components/elements/Tag";

export type CardArchiveProps = ComponentPropsWithoutRef<"div"> &
  PropsWithChildren & {
    card: TCardArchive & { tags?: TagProps[] };
    imageAspectRatio?: "4/3" | "3/4";
    primaryButton?: boolean;
  };

export const CardArchive = ({
  card,
  imageAspectRatio = "4/3",
  className,
  primaryButton = true,
  ...props
}: CardArchiveProps) => {
  const { image, title, text, link, tags } = card;
  return (
    <div className={clsx(className, styles.card)} {...props}>
      {image && (
        <div className={styles.imageWrapper}>
          {tags && (
            <div className={styles.tag}>
              {tags?.map((tag, index) => {
                return (
                  <Tag
                    size="sm"
                    label={tag.label}
                    link={tag.link}
                    key={index}
                  />
                );
              })}
            </div>
          )}

          <Image
            image={image as IImage}
            className={styles.heroImage({ aspectRatio: imageAspectRatio })}
            width={650}
          />
        </div>
      )}

      <div className={styles.contentWrapper}>
        <div className={styles.textContent}>
          {title && (
            <Heading as="h3" size="h3">
              {title}
            </Heading>
          )}

          {text && (
            <PortableText
              blocks={text as IPortableText}
              // truncateLength={150}
            />
          )}
        </div>
        {link && link.slug && (
          <div className={styles.linkContainer}>
            <ButtonLink
              link={link}
              theme="dark"
              isPrimary={primaryButton}
              icons={{ iconPrimary: <ArrowOutward /> }}
            >
              {link.text}
            </ButtonLink>
          </div>
        )}
      </div>
    </div>
  );
};
